import React, { useState } from 'react';

function Modal(props) {
  const [formData, setFormData] = useState({
    name: '',
    prelim: '',
    midterm: '',
    final: ''
  });

  function handleChange(event) {
    const { name, value } = event.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  }

  function handleSubmit(event) {
    event.preventDefault();
    props.onAddData(formData);
    setFormData({ name: '', prelim: '', midterm: '', final: '' });
    props.onClose();
  }

  return (
    <div className="modal">
      <div className="modal-overlay"></div>
      <div className="App">
        <form onSubmit={handleSubmit}>
          <label>
            Name:
            <input 
                type="text" 
                name="name" 
                value={formData.name} 
                onChange={handleChange} required />
          </label>
          <label>
            Prelim:
            <input 
                type="number" 
                name="prelim" 
                value={formData.prelim} 
                onChange={handleChange} required min="0" max="100" />
          </label>
          <label>
            Midterm:
            <input 
                type="number" 
                name="midterm" 
                value={formData.midterm} 
                onChange={handleChange} required min="0" max="100" />
          </label>
          <label>
            Final:
            <input 
                type="number" 
                name="final" 
                value={formData.final} 
                onChange={handleChange} required min="0" max="100" />
          </label>
          <button type="submit">Add Student</button>
        </form>
        <button className="close-btn" onClick={props.onClose}>Close</button>
      </div>
    </div>
  );
}

export default Modal;